import { Button, Container, Notice, Text } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import useStores from '../stores/UseStores';

const NotSupportedNotice = observer((): React.JSX.Element => {
  const {
    translateStore: { translate },
    routeStore,
  } = useStores();

  return (
    <Container>
      <Text>
        <Notice type="error">{translate('registration_not_supported.new_user')}</Notice>
        <Text className="text-center">
          <Button onClick={routeStore.navigate} url={routeStore.homePageWithParams} text={translate('ok_button_label')} iconRight="#arrow-right" />
        </Text>
      </Text>
    </Container>
  );
});

export default NotSupportedNotice;
